<template>
    <div class="dvBgiBox">
        <div style="height: 30px;">
            <p style="font-size: 22px;font-weight: 600;text-align: left;color: #fff;">{{ $t('benefits.title') }}</p>
        </div>

        <div style="width: 100%;display: flex;flex-direction: row;justify-content: center;margin-top: 10px;">
            <div class="cc">
                <div class="ccY txt">
                    <span style="font-size: 16px;color: #fff;">{{ $t('benefits.reduction') }}</span>
                    <span style="font-size: 14px;color: #fff;">{{ reduction() }}</span>
                </div>
                <div class="ccX txt">
                    <span style="font-size: 15px;color: #fff;">{{ $t('benefits.planting') }}</span>
                    <span style="font-size: 13px;color: #fff;">{{ planting() }}{{ $t('benefits.trees') }}</span>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

export default {
    data() {
        return {

        };
    },
    props: {
        photovoltaicYery: {
            default: '0Kw'
        },
    },
    watch: {

    },

    methods: {
    // 二氧化碳
    reduction() {
      let num = this.photovoltaicYery.slice(0, -2);
    //   console.log(num * 0.404);
      return (num * 0.404).toFixed(2)
    },
    // 等效植树
    planting() {
      let num = this.photovoltaicYery.slice(0, -2) * 0.404 / 5023
    //   console.log(num);
      return num.toFixed(2)
    },  

    }

}
</script>

<style scoped>
.dvBgiBox {
    width: 100%;
    padding: 5px 10px 10px 10px;
    background-image: url("../../assets/dvBgiBoxleft.png");
    background-size: 100% 100%;
    margin-bottom: 20px;
}
.cc {
    width: 240px;
    height: 220px;
    background-image: url("../../assets/left02-1.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
}

.ccY {
    margin-top: 30px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    box-shadow: 
    inset 0 13px 12px -9px #fbf8f1,
    inset 0 -17px 20px 0px #bc3b04;
}
.ccX {
    margin-top: 40px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 
    inset 0 13px 12px -9px #fbf8f1,
    inset 0 -17px 20px 0px #0163c1;
}
.txt {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>